// extracted by mini-css-extract-plugin
export default {"NCards_containerExercises":"NCardsExercise_NCards_containerExercises__UIb+C","NCards_itemBoxExercises":"NCardsExercise_NCards_itemBoxExercises__C8Oh2"};